<div [formGroup]="heroForm" class="container-bar" style="z-index: 2;">
  <div class="icon-social">
    <a (click)="opMenu(2)" class="fa-solid fa-box"
      [ngClass]="{'selected': selected === 'rastreo', 'not-selected': selected !== 'rastreo'}" id="opt_rastreo">
      <span id="title">Rastreo</span>
    </a>

    <a (click)="opMenu(0)" class="fa-solid fa-calculator"
      [ngClass]="{'selected': menuClicked === 'cotizacion', 'not-selected': menuClicked !== 'cotizacion'}"
      id="opt_cotizar">
      <span id="title">Cotizar</span>
    </a>

    <a (click)="opMenu(1)" class="fa-solid fa-people-carry-box"
      [ngClass]="{'selected': selected === 'recoleccion', 'not-selected': selected !== 'recoleccion'}"
      id="opt_recoleccion">
      <span id="title">Recolección</span>
    </a>

<a (click)="opMenu(3)"
   [ngClass]="{'selected': selected === 'promociones', 'not-selected': selected !== 'promociones'}"
   id="opt_promociones">

  <i id="icon_promos"
     class="fa-regular fa-tag"
     appVisibility
     [ngClass]="{
        'icon-selected': menuClicked === 'promociones',
        'icon-not-selected': menuClicked !== 'promociones',
        'tada2': showTada
     }"
     style="font-family: fontawesome !important;">
  </i>

  <span id="title">Promociones</span>

<div appVisibility
     class="cont_interaction"
     [class.is-visible]="showInteraction">
  Promociones
</div>
</a>

    <a (click)="opMenu(4)" class="fa-solid fa-right-to-bracket"
      [ngClass]="{'selected': selected === 'login', 'not-selected': selected !== 'login'}" id="opt_login">
      <span id="title">Acceso</span>
    </a>

    <a (click)="opMenu(5)" class="fa-solid fa-location-dot" style="border-radius: 0 0 10px 0"
      [ngClass]="{'selected': selected === 'cobertura', 'not-selected': selected !== 'cobertura'}" id="opt_cobertura">
      <span id="title">Cobertura</span>
    </a>
  </div>
</div>

<!-- Componentes según selección -->
<div style="z-index: 0;" *ngIf="selected == 'rastreo'">
  <app-rastreo></app-rastreo>
</div>
<div style="z-index: 0;" *ngIf="selected == 'cotizacion'">
  <app-cotizacion-form></app-cotizacion-form>
</div>
<div style="z-index: 0;" *ngIf="selected == 'recoleccion'">
  <app-paqueteria-recoleccion></app-paqueteria-recoleccion>
</div>
<div style="z-index: 0;" *ngIf="selected == 'promociones'">
  <app-promociones></app-promociones>
</div>
<div style="z-index: 0;" *ngIf="selected == 'login'">
  <app-gw-user-login></app-gw-user-login>
</div>
<div style="z-index: 0;" *ngIf="selected == 'cobertura'">
  <app-cobertura></app-cobertura>
</div>